"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SortComparator {
    static compareNullsLast(o1, o2) {
        if (o1 != null && o2 != null) {
            throw new Error("at least one parameter must be null");
        }
        if (o1 === null) {
            return 1;
        }
        if (o2 === null) {
            return -1;
        }
        return 0;
    }
    constructor(gridConfig, gridDataManager) {
        this.gridConfig = gridConfig;
        this.gridDataManager = gridDataManager;
    }
    compare(o1, o2) {
        if (o1 === undefined) {
            if (o2 === undefined) {
                return 0;
            }
            return 1;
        }
        if (o2 === undefined) {
            return -1;
        }
        const firstColumn = this.gridConfig.getColumn(this.gridDataManager.getSortedByColumn());
        const secondColumn = this.gridConfig.getColumn(this.gridDataManager.getSortedByColumn());
        const a = firstColumn.getSortableData?.(o1) ?? firstColumn.getData(o1);
        const b = secondColumn.getSortableData?.(o2) ?? secondColumn.getData(o2);
        if (a === undefined) {
            if (b === undefined) {
                return 0;
            }
            return 1;
        }
        if (b === undefined) {
            return -1;
        }
        if (a === null || b === null) {
            return SortComparator.compareNullsLast(a, b);
        }
        if (typeof a === "number" && typeof b === "number") {
            return a - b;
        }
        if (typeof a === "string" && typeof b === "string") {
            if (a === "" && b === "") {
                return 0;
            }
            if (a === "") {
                return 1;
            }
            if (b === "") {
                return -1;
            }
            return a.localeCompare(b);
        }
        if (a instanceof Date && b instanceof Date) {
            return a.getTime() - b.getTime();
        }
        return a.toString().localeCompare(b.toString());
    }
}
exports.default = SortComparator;
//# sourceMappingURL=SortComparator.js.map